import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SmartCaptchaService } from '@core/feature';
import { EffectsModule } from '@ngrx/effects';
import { UserAccountRootModule } from '@spartacus/user';
import { effects } from './effects';
import {
  AuthTypeInterceptor,
  LogoutInterceptor,
  SubmitAuthCodeInterceptor,
  TokenReceiveErrorInterceptor,
} from './http-interceptors';

@NgModule({
  imports: [UserAccountRootModule, EffectsModule.forFeature(effects)],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: AuthTypeInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: TokenReceiveErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: SubmitAuthCodeInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: LogoutInterceptor,
      multi: true,
    },
    SmartCaptchaService,
  ],
})
export class UserFeatureModule {}
